import React, { useState, useEffect } from "react";
import ConnectToCalendarView from "./connect";
import ConnectedCalendars from "./connected";
import "../../admin/calendar-integrations/calendar-integrations-v2.scss";
import Loader from "../../../components/Loader/Loader";
import { useSearchParams } from "react-router-dom";
import { notification } from "../../../utils/utility";
import useFeatureRedirect from "../../../hooks/useFeatureRedirect";
import { FEATURE_IDS } from "../../../constants/featureAccess";
import axios from "../../../axios-instance";
import { getStaffBusinessId } from "../../../utils/authHelper";

const StaffCalendarIntegration = () => {
  useFeatureRedirect(FEATURE_IDS.CALENDAR_INTEGRATIONS, "/staff/dashboard");
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allowance, setAllowance] = useState(1);
  const [view, setView] = useState("1");

  const loadCalendars = () => {
    const businessId = getStaffBusinessId();
    if (!businessId) {
      setView("2");
      return;
    }
    setIsLoading(true);
    axios
      .get(`admin/get-connected-calendars/${businessId}?owner=staff`)
      .then((res) => {
        const payload = res?.data?.data || res?.data || {};
        const entity = payload.entity || [];
        setAllowance(Number(payload.staff_calendar_allowance || 1));
        if (entity.length) {
          setData(entity);
          setView("1");
        } else {
          setData([]);
          setView("2");
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (searchParams.get("error")) {
      notification.error(searchParams.get("error"));
    }
    loadCalendars();
  }, []);

  return (
    <>
      <Loader isShowLoader={isLoading} />
      {!isLoading && view === "1" && (
        <ConnectedCalendars
          data={data}
          allowance={allowance}
          setCalendarIntegrationView={setView}
          setIntegrationDataSet={setData}
        />
      )}
      {!isLoading && view === "2" && (
        <ConnectToCalendarView
          data={data}
          allowance={allowance}
          setCalendarIntegrationView={setView}
        />
      )}
    </>
  );
};

export default StaffCalendarIntegration;
